export default __webpack_public_path__ + "static/media/db.d154953d.svg";